// extracted by mini-css-extract-plugin
module.exports = {"dropdownWidth":"G7Tqmw","isMobile":"BdDSw9","dropdownAlignment":"Ga5V6f","buttonOption":"tyPziK","strikethrough":"Jcaujp","fitToText":"Rp5v73","flexGrow":"cLugmj"};